import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M8.87.38H23.13V4.85h3V31.62H5.85V4.85h3Zm1.77,4.47H21.36V2.14H10.64Zm-3,1.76V29.86H17.84V22.79h3.55v7.07h3V6.61Zm3,6.79V9.85h3.55V13.4Zm7.23,0V9.85h3.55V13.4Zm-7.23,6.47V16.32h3.55v3.55Zm7.23,0V16.32h3.55v3.55Zm-7.23,6.47V22.79h3.55v3.55Z' })
));